import * as React from 'react';

/**
 * Reusable component for the required field marker
 * @param props
 */
const RequiredFieldMarker: React.SFC<any> = () => {
	return <span className="required-field-marker">(required)</span>;
};

export default RequiredFieldMarker;
